// components/Sidebar.js
import React, { useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../styles/Sidebar.css";
import { ReactComponent as GradientBoldLogo } from "../assets/Transparent svg/Bold Logo with Text/Gradient Bold Logo.svg";

const Sidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const handleNavigation = (path) => {
    if (currentPath !== path) navigate(path);
    onClose();
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("guest");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("isGoogleUser");
    localStorage.removeItem("hasAccount");
    navigate("/login");
  };

  // Close on outside click (for mobile)
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (window.innerWidth <= 768 && isOpen && !e.target.closest(".sidebar")) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, onClose]);

  // Get user from localStorage
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const userName = user?.name || "Guest User";

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}

      <div className={`sidebar ${isOpen ? "open" : ""}`}>
        {/* Close icon for mobile */}
        {isOpen && (
          <button className="sidebar-close" onClick={onClose}>
            <img src="/close.svg" alt="Close Sidebar" />
          </button>
        )}

        <div>
          <div className="logo">
            <Link to="/" onClick={onClose}>
              <GradientBoldLogo className="navbar-logo" />
            </Link>
          </div>

          <ul>
            <li
              className={`sidebar-item ${currentPath === "/dispatch-history" ? "active" : ""}`}
              onClick={() => handleNavigation("/dispatch-history")}
            >
              <img
                src={currentPath === "/dispatch-history" ? "/senddocumentL.svg" : "/senddocument.svg"}
                alt="History"
                className="sidebar-icon"
              />
              <span>History</span>
              {currentPath === "/dispatch-history" && (
                <img src="/forward.svg" alt="forward" className="forward-icon" />
              )}
            </li>

            <li
              className={`sidebar-item ${currentPath === "/dashboard" ? "active" : ""}`}
              onClick={() => handleNavigation("/dashboard")}
            >
              <img
                src={currentPath === "/dashboard" ? "/senddocumentL.svg" : "/senddocument.svg"}
                alt="Send"
                className="sidebar-icon"
              />
              <span>Send Document</span>
              {currentPath === "/dashboard" && (
                <img src="/forward.svg" alt="forward" className="forward-icon" />
              )}
            </li>

            <li
              className={`sidebar-item ${currentPath === "/create" ? "active" : ""}`}
              onClick={() => handleNavigation("/create")}
            >
              <img
                src={currentPath === "/create" ? "/createdocL.svg" : "/createdoc.svg"}
                alt="Create"
                className="sidebar-icon"
              />
              <span>Create Document</span>
              {currentPath === "/create" && (
                <img src="/forward.svg" alt="forward" className="forward-icon" />
              )}
            </li>
          </ul>
        </div>

        <div className="profile">
          <p>{userName}</p>
          <button className="logout-btn" onClick={handleLogout}>
            🚪 Sign Out
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;